/**
 * Created by Rodrigo Quesada on 06/01/17.
 */
export class ProgramInfo {
    completed?: boolean;
    notCompletedExplanation?: string;
    programChair?: string;

    constructor(jsonData: any = {}) {
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/common/values/program-info.class.ts